export const enablerFeatureTitles = {
  favoritesFAQPopover: 'LS-3157',
  atiTheme: 'atiThemeInformer',
  darkThemePopupUpdate: 'darkThemePopupUpdate',
  newFavoritesTabPopover: 'newFavoritesTabPopover',
};
